class UtilService {
    /**
     * Smooth scrolling with plain JS. Watch out for performance impact
     * Source: https://gist.github.com/andjosh/6764939
     */
    public scrollToAnimated(scrollContainer: HTMLElement, scrollToY: number, duration: number = 350) {
        const start = scrollContainer.scrollTop;
        const change = scrollToY - start;
        let currentTime = 0;
        const increment = 20;

        const animateScroll = () => {
            currentTime += increment;
            const newScrollTop = this.easeInOutQuad(currentTime, start, change, duration);
            scrollContainer.scrollTop = newScrollTop;
            if (currentTime < duration) {
                setTimeout(() => animateScroll(), increment);
            } else {
                scrollContainer.scrollTop = scrollToY;
            }
        };
        animateScroll();
    }

    public easeInOutQuad(currentTime: number, start: number, change: number, duration: number) {
        currentTime /= duration / 2;
        if (currentTime < 1) {
            return (change / 2) * currentTime * currentTime + start;
        }
        currentTime--;
        return (-change / 2) * (currentTime * (currentTime - 2) - 1) + start;
    }
}

export const utilService = new UtilService();
